import React from 'react';
import Icon from './Icon';

const Logo = () => (
    <div className="flex items-center space-x-2">
        {/* <Icon path="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 013-3h.008c1.538 0 2.94.836 3.697 2.121A3.004 3.004 0 0112 4.5v6.75a3 3 0 01-3 3z" className="w-8 h-8 text-indigo-500" /> */}
        <span className="text-2xl font-bold font-sansation text-white" style={{fontFamily: "'Sansation', sans-serif"}}>SYNCRATIK</span>
    </div>
);

export default Logo;

